import React from "react";
import Header from "../../components/Header";
import { Outlet, useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";
import { isMobile } from "react-device-detect";
import MobileHeader from "../../components/mobile/mobileHeader";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

export const MainContainer = () => {
    const navigate = useNavigate();
    const showMobileHeader = useSelector((state: RootState) => state.mobileLayout.showTopBackNav);
    const passwordSetupStatus = useSelector((state: RootState) => state.profile.passwordSetupStatus);

    const renderMobileStyle = () => {
        const defaultStyle = {
            position: "relative",
            top: "65px",
            height: `calc(100vh - 65px)`,
            overflow: "auto",
            minWidth: 0,
        };
        if (isMobile) {
            return {
                position: "relative",
                overflow: "auto",
                minWidth: 0,
            };
        } else {
            return defaultStyle;
        }
    };

    return (
        <Box display={"flex"} flexDirection={"column"}>
            {isMobile ? showMobileHeader ? <MobileHeader /> : null : <Header />}
            <Box sx={renderMobileStyle}>
                {passwordSetupStatus?.show_password_setup_banner && (
                    <Box sx={{ px: 2, pt: 2, pb: 1 }}>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                alignItems: { xs: "flex-start", sm: "center" },
                                justifyContent: "space-between",
                                gap: 2,
                                px: 2,
                                py: 1.5,
                                borderRadius: 2,
                                borderLeft: "4px solid #d97706",
                                backgroundColor: "#fffbeb",
                                boxShadow: "0 8px 24px rgba(17, 24, 39, 0.08)",
                            }}
                        >
                            <Box>
                                <Box sx={{ fontSize: 14, fontWeight: 700, color: "#111827" }}>
                                    First-time login: set your password
                                </Box>
                                <Box sx={{ fontSize: 13, color: "#4b5563", mt: 0.5 }}>
                                    Your account needs a personal password before you continue.
                                </Box>
                            </Box>
                            <Button
                                variant="contained"
                                onClick={() => navigate("/profile-management")}
                                sx={{
                                    alignSelf: { xs: "stretch", sm: "center" },
                                    backgroundColor: "#d97706",
                                    color: "#fff",
                                    "&:hover": {
                                        backgroundColor: "#b45309",
                                    },
                                }}
                            >
                                Change Password
                            </Button>
                        </Box>
                    </Box>
                )}
                <Outlet />
            </Box>
        </Box>
    );
};
